<template src="./template.html" />

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      default: 'airplane'
    },
    size: {
      type: [Number, String],
      default: 18,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    fillColor: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: 'circled-icon',
    }
  },
  data: () => ({
    icon: null
  }),
  mounted() {
    this.fetchIcon()
  },
  watch: {
    name(newVal) {
      if (newVal) {
        this.fetchIcon();
      }
    }
  },
  methods: {
    async fetchIcon() {
      const { name } = this
      try {
        const icon = await import(`./icons/${name}.vue`);
        this.icon = icon?.default
      } catch (e) {
        throw Error(`Icon ${name} dodesn't exist!`);
      }
    }
  },
}
</script>
